import type { DashboardSearchHit, DashboardSummary } from '@todo/shared';
import { get } from './client';

export const dashboardApi = {
  /** GET /api/dashboard - the whole Dashboard screen in one read. */
  get(): Promise<DashboardSummary> {
    return get<DashboardSummary>('/dashboard');
  },
  /** GET /api/dashboard/search - "Search everything". */
  search(q: string): Promise<DashboardSearchHit[]> {
    return get<DashboardSearchHit[]>('/dashboard/search', { q });
  },
};
